const rem = (px) => {
  let rem = (px / 16) + "rem";
  return rem;
}

export default rem